export enum CollectionsGroup {
  USER = 'user',
  APPS = 'apps',
  EXTERNAL = 'external',
}
